import { defineSaleProgress, isSaleCreated, isSaleStarted, type ProgressSaleData } from '../saleProgress'

interface RetentionData extends ProgressSaleData {
  scriptSteps?: Record<string, string> | null
}

const PULSE = 'additionalSales:pulse.'

export default defineSaleProgress<RetentionData>({
  kind: 'sale',
  cascade: true,
  steps: [
    {
      key: 'eligibility',
      label: 'additionalSales:leadRetentionVa.progress.eligible',
      done: data => !!data.scriptSteps?.eligibility,
    },
    { key: 'created', label: `${PULSE}timeline.created`, done: isSaleCreated },
  ],
  status: (data, steps) => {
    if (steps[steps.length - 1].state === 'done') return 'signed'
    if (isSaleStarted(data) || steps.some(step => step.state === 'done')) return 'progress'

    return 'new'
  },
  doneLabel: `${PULSE}progress.sale_created`,
})
